import { styled } from '@nykaa/ui-components';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => hexToRgb(theme.colors.state, 0.12)};
  border-radius: ${({ theme }) => theme.borders.radius10};
  color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.92)};
  padding: ${({ theme }) => theme.spacing.spacing40}
    ${({ theme }) => theme.spacing.spacing80};
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
  line-height: 1.4;
  max-width: 92%;
`;

export const OfferList = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  padding-left: ${({ theme }) => theme.spacing.spacing60};
  position: relative;
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  &::before {
    content: '•';
    padding-right: ${({ theme }) => theme.spacing.spacing40};
    position: absolute;
    left: 0;
  }
`;

export const OfferSkeleton = styled.div`
  height: 40px;
  width: 100%;
  background: transparent;
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
`;

export const MiniOffersWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: ${({ theme }) => theme.spacing.spacing40} 0;
  width: 100%;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;

  /* Ensure children don't shrink */
  & > * {
    flex-shrink: 0;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.textOutline};
  margin: ${({ theme }) => theme.spacing.spacing80} 0;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
  align-items: center;
`;

export const OfferHeading = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-right: ${({ theme }) => theme.spacing.spacing40};
`;

export const OfferText = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-left: ${({ theme }) => theme.spacing.spacing40};
`;

export const Dot = styled.img``;
